import { render, staticRenderFns } from "./FoodDistributionEnrollmentChanges.vue?vue&type=template&id=0ad4fd52&"
import script from "./FoodDistributionEnrollmentChanges.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionEnrollmentChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports